<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card" style="margin-left: 10px">
      <div class="card-body">
        <h5 class="card-title">
          레벨테스트 응시
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            레벨테스트 관리 → 레벨테스트 응시
          </div>
        </h5>

        <div
          style="
            width: 1000px;
            height: auto;
            background: #fff;
            text-align: center;
            margin: 50px auto;
            box-shadow: 0 0 10px #ccc;
            padding-bottom: 30px;
          "
        >
          <img src="../assets/img/title_leveltest.png" />
          <div
            style="
              text-align: left;
              width: 980px;
              padding: 8px 0px 0px 8px;
              margin: 10px auto;
              font-size: 15px;
            "
          >
            <span style="font-size: 16px; font-weight: bold"
              >ChildU PLS Placement Test</span
            >를 진행할 학생의 정보를 정확히 입력해주세요!
          </div>
          <div
            style="
              height: 60px;
              background: #246181;
              color: #fff;
              font-size: 24px;
              font-weight: bold;
              margin-top: 20px;
              line-height: 60px;
            "
          >
            Student's Information
          </div>
          <div>
            <table
              border="0"
              style="border-bottom: 0; background: #f0f0f0; width: 100%"
            >
              <tbody>
                <tr>
                  <th width="80" style="padding: 10px">
                    <div
                      class="blue_th"
                      style="
                        background: #59ceff;
                        font-size: 14px;
                        color: #fff;
                        width: 90px;
                        height: 28px;
                        text-align: center;
                        line-height: 28px;
                        font-weight: normal;
                        border-radius: 10px;
                      "
                    >
                      학년
                    </div>
                  </th>
                  <td>
                    <select
                      name="t_job1"
                      class="input_text"
                      v-model="job"
                      style="
                        width: 80px;
                        text-align: center;
                        margin-left: -35px;
                      "
                    >
                      <option value="">선택</option>
                      <option value="미취학">미취학</option>
                      <option value="초등">초등</option>
                      <option value="중등">중등</option>
                      <option value="고등">고등</option>
                      <option value="기타">기타</option>
                    </select>
                  </td>
                  <th width="80">
                    <div
                      class="blue_th"
                      style="
                        background: #59ceff;
                        font-size: 14px;
                        color: #fff;
                        width: 90px;
                        height: 28px;
                        text-align: center;
                        line-height: 28px;
                        font-weight: normal;
                        border-radius: 10px;
                      "
                    >
                      연락처
                    </div>
                  </th>
                  <td>
                    <input
                      name="t_phone"
                      type="text"
                      class="input_text"
                      v-model="phone"
                      style="margin-left: -60px"
                    />
                  </td>
                  <!--th width="80"><div class="blue_th">날짜</div></th>
              <td><input type="date
                "></td>
        		  <input type="hidden" name="strGrade" -->
                  <th width="80">
                    <div
                      class="blue_th"
                      style="
                        background: #59ceff;
                        font-size: 14px;
                        color: #fff;
                        width: 90px;
                        height: 28px;
                        text-align: center;
                        line-height: 28px;
                        font-weight: normal;
                        border-radius: 10px;
                      "
                    >
                      이름
                    </div>
                  </th>
                  <td>
                    <input
                      type="text"
                      v-model="name"
                      style="margin-left: -80px"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            style="
              text-align: left;
              width: 900px;
              margin: 20px;
              font-size: 15px;
              margin-bottom: 40px;
              line-height: 30px;
            "
          >
            - 모든 문항은
            <span style="font-weight: bold; color: #980f93"
              >미국 교과과정의 Language Arts 영역</span
            >으로 평가문항이 구성되었습니다.<br />

            - Level 1~4까지는
            <span style="font-weight: bold; color: #0068d5"
              >LC 10문항 / RC 15문항 총 25문항</span
            >으로 구성되었습니다. (권장 소요시간 30분 내외)<br />

            - Level 5~6은
            <span style="font-weight: bold; color: #0068d5">RC 33문항</span>으로
            구성되었습니다. (권장소요시간 40분 내외)
          </div>

          <div style="width: 850px; margin: 0 auto">
            <div class="test_box_wrap">
              <div id="outcircle"><div id="incircle">L1</div></div>
              <div class="test_box">
                <div class="box1">
                  <p style="color: #9ed443; font-weight: bold">
                    7~8세(GK001~002) - Phonics
                  </p>
                  <span
                    >영어를 처음 시작하는 학생<br />
                    알파벳을 알고 단모음, 단자음, 짧은<br />문장을 읽고,
                    이해하는 학생</span
                  >
                </div>

                <div class="box2">
                  <a @click="testgo('Phonics')"
                    ><p class="test_bg">
                      <i class="fas fa-edit"></i>
                      TEST
                    </p></a
                  >

                  <span style="font-size: 13px; text-align: left"
                    >Listening :<span style="font-weight: bold">10문제</span
                    ><br />
                    Reading :
                    <span style="font-weight: bold">15문제</span></span
                  >
                </div>
              </div>
              <!--test_box_wrap -->
            </div>

            <div class="test_box_wrap" style="margin-left: 200px">
              <div id="outcircle" style="background: #5cd443">
                <div id="incircle">L2</div>
              </div>
              <div class="test_box">
                <div class="box1">
                  <p style="color: #5cd443; font-weight: bold">
                    7~10세(GK003~005) - Kinder
                  </p>
                  <span
                    >영어를 6개월~1년 이상 학습한 학생<br />
                    이중자음, 이중모음을 구분하고 패턴 스토리를 읽고, 이해할 수
                    있는 학생</span
                  >
                </div>

                <div class="box2">
                  <a @click="testgo('kinder')"
                    ><p class="test_bg">
                      <i class="fas fa-edit"></i>
                      TEST
                    </p></a
                  >

                  <span style="font-size: 13px; text-align: left"
                    >Listening :<span style="font-weight: bold">10문제</span
                    ><br />
                    Reading :
                    <span style="font-weight: bold">15문제</span></span
                  >
                </div>
              </div>
              <!--test_box_wrap -->
            </div>
            <div class="test_box_wrap">
              <div
                id="outcircle"
                style="background: #43cfd4; border-color: #1cb8be"
              >
                <div id="incircle">L3</div>
              </div>
              <div class="test_box">
                <div class="box1">
                  <p style="color: #43cfd4; font-weight: bold">
                    8~11세(GR101~106) - LEVEL1
                  </p>
                  <span
                    >영어를 1~3년 이상 학습한 학생<br />
                    읽기가 편하고, 독해 전략과 논픽션 리딩을 통해 영어의
                    기본기를<br />훈련할 학생
                  </span>
                </div>

                <div class="box2">
                  <a @click="testgo('1')"
                    ><p class="test_bg">
                      <i class="fas fa-edit"></i>
                      TEST
                    </p></a
                  >

                  <span style="font-size: 13px; text-align: left"
                    >Listening :<span style="font-weight: bold">10문제</span
                    ><br />
                    Reading :
                    <span style="font-weight: bold">15문제</span></span
                  >
                </div>
              </div>
              <!--test_box_wrap -->
            </div>
            <div class="test_box_wrap" style="margin-left: 200px">
              <div
                id="outcircle"
                style="background: #4387d4; border-color: #4387d4"
              >
                <div id="incircle">L4</div>
              </div>
              <div class="test_box" style="border-color: #4387d4">
                <div class="box1">
                  <p style="color: #4387d4; font-weight: bold">
                    10~12세(GR201~206)
                  </p>
                  <span
                    >영어를 3~4년 이상 학습한 학생<br />
                    듣기, 읽기가 편하고, 독해 전략과<br />
                    논픽션 리딩을 통해 영어의<br />
                    기본기를 확장하고 싶은 학생
                  </span>
                </div>

                <div class="box2">
                  <a @click="testgo('2')"
                    ><p class="test_bg">
                      <i class="fas fa-edit"></i>
                      TEST
                    </p></a
                  >

                  <span style="font-size: 13px; text-align: left"
                    >Listening :<span style="font-weight: bold">10문제</span
                    ><br />
                    Reading :
                    <span style="font-weight: bold">15문제</span></span
                  >
                </div>
              </div>
              <!--test_box_wrap -->
            </div>
            <div class="test_box_wrap">
              <div
                id="outcircle"
                style="background: #d48043; border-color: #d48043"
              >
                <div id="incircle">L5</div>
              </div>
              <div class="test_box" style="border-color: #d48043">
                <div class="box1">
                  <p style="color: #d48043; font-weight: bold">
                    11세~13세(GR301~304)
                  </p>
                  <span
                    >영어를 4~5년 이상 학습한 학생<br />
                    듣기/읽기가 편하고, 영어를 영어로 이해할 수 있는 학생, 원서
                    교과목으로 교과지식을 습득하고 싶은 학생
                  </span>
                </div>

                <div class="box2">
                  <a @click="testgo('3')"
                    ><p class="test_bg">
                      <i class="fas fa-edit"></i>
                      TEST
                    </p></a
                  >

                  <span style="font-size: 16px; text-align: left">
                    Reading :
                    <span style="font-weight: bold">33문제</span></span
                  >
                </div>
              </div>
              <!--test_box_wrap -->
            </div>
            <div class="test_box_wrap" style="margin-left: 200px">
              <div
                id="outcircle"
                style="background: #d44346; border-color: #d44346"
              >
                <div id="incircle">L6</div>
              </div>
              <div
                class="test_box"
                style="border-color: #d44346; height: 160px"
              >
                <div class="box1">
                  <p style="color: #d44346; font-weight: bold">
                    12~15세(GR401~404)
                  </p>
                  <span
                    >영어를 4~6년 이상 학습한 학생<br />
                    듣기, 읽기가 편해서 영어를 영어로 이해하고 영어로 요약해서
                    발표를 할 수 있는 학생, 원서 교과목으로<br />교과지식을
                    습득하고 싶은 학생
                  </span>
                </div>

                <div class="box2">
                  <a @click="testgo('4')"
                    ><p class="test_bg">
                      <i class="fas fa-edit"></i>
                      TEST
                    </p></a
                  >

                  <span style="font-size: 16px; text-align: left">
                    Reading :
                    <span style="font-weight: bold">33문제</span></span
                  >
                </div>
              </div>
            </div>
            <!--test_box_wrap -->
          </div>

          <!--wrap -->
        </div>

        <div
          class="col-lg-6 offset-lg-3 search_box"
          v-if="this.$root.guiPerm == 'ROOT'"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import axios from "axios";
export default {
  name: "Home",
  components: {
    Tree,
  },
  mounted() {},
  methods: {
    testgo(level) {
      axios
        .post("/leveltest", {
          level: level,
          name: this.name,
          phone: this.phone,
          job: this.job,
        })
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "생성 실패하였습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            $.notify(
              {
                // options
                message: "리다이렉트 중입니다...",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            var openNewWindow = window.open("about:blank");
            openNewWindow.location.href = response.data.url;
          }
        });
    },
  },
  data() {
    return {
      name: "",
      phone: "",
      job: "",
    };
  },
};
</script>
